import myAxios from './axiositeachWrapper';
import Config from '../_config/config';

const BASE = `${Config.nodeSiteUrl}v1/postbox-messages`;

export interface PostboxMessage {
  id: number;
  name: string | null;
  channelId: number | null;
  target: string | null;
  bcc: string | null;
  cc: string | null;
  subject: string | null;
  message: string | null;
  status: string | null;
  type: string | null;
  userId: number | null;
  enrollmentId: number | null;
  enquiryId: number | null;
  source: string | null;
  sourceDisplayName: string | null;
  saveDate: string | null;
  sendDate: string | null;
  deliveredDate: string | null;
  sesMessageId: string | null;
  sesNotificationType: string | null;
  sesNotificationDetails: string | null;
  exception: string | null;
  gatewayResponse: string | null;
  reason: string | null;
}

export interface PostboxMessagesResponse {
  success: boolean;
  data: PostboxMessage[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export interface PostboxMessagesFilters {
  status?: string | string[];
  channelId?: number;
  name?: string;
  q?: string;
  fromDate?: string;
  toDate?: string;
  userId?: number;
  enrollmentId?: number;
  page?: number;
  pageSize?: number;
}

export const listPostboxMessages = async (
  filters?: PostboxMessagesFilters,
): Promise<PostboxMessagesResponse> => {
  const params = new URLSearchParams();
  if (filters) {
    if (filters.status) {
      const v = Array.isArray(filters.status)
        ? filters.status.join(',')
        : filters.status;
      params.append('status', v);
    }
    if (filters.channelId !== undefined)
      params.append('channelId', String(filters.channelId));
    if (filters.name) params.append('name', filters.name);
    if (filters.q) params.append('q', filters.q);
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.userId !== undefined)
      params.append('userId', String(filters.userId));
    if (filters.enrollmentId !== undefined)
      params.append('enrollmentId', String(filters.enrollmentId));
    if (filters.page !== undefined) params.append('page', String(filters.page));
    if (filters.pageSize !== undefined)
      params.append('pageSize', String(filters.pageSize));
  }
  const qs = params.toString();
  const response: any = await myAxios.get(`${BASE}${qs ? `?${qs}` : ''}`);
  return response.data as PostboxMessagesResponse;
};

export const CHANNEL_LABEL: Record<number, string> = {
  1: 'Email',
  2: 'SMS',
  3: 'Push',
  4: 'In-app',
  5: 'WhatsApp',
};
